import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'

import App from './App.vue'

document.querySelectorAll('.micro-srp').forEach(element => {
  const app = createApp(App, {
    accountId: element.getAttribute('data-account-id'),
    placementId: element.getAttribute('data-placement-id'),
  })
  app.use(vuetify)
  app.use(createPinia())
  app.mount(element)
})
